import { SET_IS_LOADING, SET_IS_ERROR, SET_LAST_ERROR, SET_MESSAGE } from './mutationTypes'
import {i18n} from "../lang/setup";

function prepareResponse(commit) {
  commit(SET_IS_LOADING, true)
}

function requestFinished(commit) {
  commit(SET_IS_LOADING, false)
}

function resetError (commit) {
  commit(SET_IS_ERROR, false)
  commit(SET_LAST_ERROR, null)
  commit(SET_MESSAGE, null)
}

function getRequiresActionError(error) {
  if (error && error.response && error.response.errors && error.response.errors.length > 0 && error.response.errors[0].code == 422) {
    return error.response.errors[0];
  }
  return false;
}

function handleError (commit, error) {
  commit(SET_IS_ERROR, true)
  requestFinished(commit)

  let message = null
  if (error && typeof(error) == 'string') {
    message = error
  } else if (error && error.response && error.response.errors) {
    let errors = []
    let err
    for(let key in error.response.errors) {
      err = error.response.errors[key]
      if (err.hasOwnProperty('message')) {
        if (err.message) {
          errors.push(err.message)
        }
      }
      if (err.hasOwnProperty('changeset') && err.changeset.hasOwnProperty('errors')) {
        for (let key in err.changeset.errors) {
          message = err.changeset.errors[key]
          key = key.replace('_hash', '')
          errors.push(key + ' ' + message)
        }
      }
    }
    message = errors.join("<br>")
  } else if (error && error.response && error.response.error) {
    message = error.response.error
  }
  if (message!=null) {
    commit(SET_LAST_ERROR, message)
    commit(SET_MESSAGE, {type: 'error', text: message})
    return Promise.reject(error)
  }

  commit(SET_LAST_ERROR, "An unexpected error occurred")
  return Promise.reject(error)
}

function skipWelcomeEmail(membership) {
  if (!membership.valid) {
    // probably membership is awaiting approval - we skip the email for now.
    return true;
  }
  const membershipType = membership.membershipType;
  return membershipType && membershipType.metaValues.find(({key, value}) => key.trim() == 'skip_welcome_email' && value.trim() == 'true')!=null;
}

function getTermsUrl(membershipType) {
  const metaValue = membershipType.metaValues.find(({key, locale}) => key == 'terms_url' && locale== i18n.locale);
  return metaValue ? metaValue.value : getDefaultTermsUrl();
}

function getDefaultTermsUrl() {
  return process.env.FG_TERMS_URL;
}

function getDefaultPrivacyUrl() {
  return process.env.FG_PRIVACY_URL;
}

export {
  prepareResponse,
  requestFinished,
  resetError,
  handleError,
  getRequiresActionError,
  skipWelcomeEmail,
  getTermsUrl,
  getDefaultTermsUrl,
  getDefaultPrivacyUrl
}
